<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="car_type" slot-scope="params">
        <span v-if="params.params.car_type == 1">车头证件</span>
        <span v-if="params.params.car_type == 2">挂车证件</span>
      </template>
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="`1`" :inactiveValue="`0`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'car',
      getListUrl: 'documentauthrec',
      modalSubmitUrl: 'adddocumentauth',
      delUrl: 'deldocumentauth',
      breadcrumb: [
        { name: "系统设置" },
        { name: "车辆证件配置" },
      ],
      formCtrl: [
        {
          label: "",
          keyName: "type_name",
          placeholder: "请填写证件名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "type_name", label: "证件名称" },
        { keyName: "car_type", label: "证件类型", slot: 'car_type' },
        { keyName: "user_name", label: "创建人" },
        { keyName: "sort", label: "排序" },
        { keyName: "is_view", label: "是否显示", slot: 'isdisplay' },
        { keyName: "created_at", label: "添加时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: '请填写证件名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "证件名称",
          keyName: "type_name",
          err: "请填写证件名称",
          type: "text",
        },
        {
          label: "证件类型",
          keyName: "car_type",
          type: "radio",
          options: [
            { label: '车头', value: 1 },
            { label: '挂车', value: 2 },
          ],
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          unit: "数字越大排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "is_view",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.open = v.is_view + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id, is_view }) {
      console.log(id)
      let display = (is_view === 1 ? 0 : 1)
      let url = `${this.baseUrl}/adddocumentauth`;
      const params = {
        userid: this.user.id,
        id,
        is_view: display
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    add() {
      delete this.mform.id
      this.mform = { type_name: undefined }
      this.title = '添加'
      this.showDialog()
    },
    getItem({ id, type_name, is_view, sort, car_type }) {
      this.mform = { ...this.mform, id, type_name, sort, is_view, car_type }
      this.title = '修改'
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>